"use client";
import React from "react";

const StatsSection = () => {
  const stats = [
    {
      value: "10x",
      label: "Faster Screening",
      description: "Screen candidates in minutes, not days"
    },
    {
      value: "70%",
      label: "Time Saved",
      description: "Reduction in time-to-fill positions"
    },
    {
      value: "15+",
      label: "Languages",
      description: "Including Indian vernacular languages"
    },
    {
      value: "24/7",
      label: "Availability",
      description: "AI interviews anytime, anywhere"
    }
  ];

  return (
    <section className="relative py-24 bg-white">
      {/* Gradient accent line */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-accent/30 to-transparent" />
      
      <div className="max-w-6xl mx-auto px-6">
        {/* Section header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-jacarta-700 mb-4">
            Results that{" "}
            <span className="text-accent">
              speak
            </span>
          </h2>
          <p className="text-jacarta-500 text-lg max-w-2xl mx-auto">
            Transform your recruitment process with AI that delivers measurable impact
          </p>
        </div>

        {/* Stats grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat, index) => (
            <div 
              key={index}
              className="relative group p-6 md:p-8 rounded-2xl bg-[#F3F1FA] border border-accent/10 hover:border-accent/30 hover:shadow-lg hover:shadow-accent/5 transition-all duration-500"
            >
              {/* Glow effect on hover */}
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-accent/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              
              <div className="relative">
                <div className="text-4xl md:text-5xl lg:text-6xl font-bold text-accent">
                  {stat.value}
                </div>
                <div className="mt-2 text-lg font-semibold text-jacarta-700">
                  {stat.label}
                </div>
                <p className="mt-2 text-sm text-jacarta-500">
                  {stat.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
